import { ENV_DEV } from "../../../utils/window";

/**
 * Remove attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 * @param {String} values
 */
const attributeRemove = (targets, name, values) => {
  if (ENV_DEV && !name) {
    console.error(
      `[TorusKit error]: No attribute name provided in the \`remove(attribute)\` action. Please use the \`<name>\` option to specify the attribute name you want to remove.`
    );

    return;
  }

  for (const target of targets) {
    /** Original attribute values */
    const original =
      /** @type {String} */ (target.getAttribute(name)) || "";

    /** Values to be removed are defined */
    if (values) {
      target.setAttribute(name, original.replace(values, "").trim());
    } else {
      /** No values defined. Remove whole attribute */
      target.removeAttribute(name);
    }
  }
};

export default attributeRemove;
